
import { Getter, GetterTree } from "vuex";
import State from "./state";
import { IUserLoginInfoModel, IMenuModel } from "src/model";

export function accessToken(state: State): string
{
    // 首先从 vuex 中获取
    let accessToken: string = state.accessToken;

    if(!accessToken)
    {
        accessToken = localStorage.getItem("accessToken") || "";
    }
    
    return accessToken;
}

export function userInfo(state: State): Array<IMenuModel>
{
    let userInfo = state.userInfo;
    if(!userInfo)
    {
        userInfo = JSON.parse(localStorage.getItem("userInfo"));
    }
    
    return userInfo;
}

export function menuData(state: State): Array<IMenuModel>
{
    let menuData = state.menuData;
    if((menuData && menuData.length === 0) || !menuData)
    {
        let menuStorage = localStorage.getItem("menuData") || "[]";
        menuData = JSON.parse(menuStorage);
    }
    
    return menuData;
}

export function isLogin(state: State): number
{
    let isLogin = state.isLogin;

    return isLogin;
}

export function tenantId(state: State): string | number
{
    // 首先从 vuex 中获取
    let tenantId: string | number = state.tenantId;

    if(!tenantId)
    {
        tenantId = localStorage.getItem("tenantId") || "";
    }
    
    return tenantId;
}

export default <GetterTree<State, any>>
{
    accessToken,
    menuData,
    isLogin,
    tenantId,
    userInfo
};
